export const ACTIONS = {
  HANDLE_SUCCESS_GET_SUBSCRIPTIONS: 'handleSuccessGetSubscriptions',
  FETCHING_SUBSCRIPTIONS: 'fetchingSubscriptions',
  HANDLE_SUCCESS_GET_SUBSCRIPTION_PLANS: 'handleSuccessGetSubscriptionPlans',
  FETCHING_SUBSCRIPTION_PLANS: 'fetchingSubscriptionPlans',
};
